<script>

	import axios from 'axios'
	import { required, email } from 'vuelidate/lib/validators'
	import Fragment from '@/components/Fragment'
	import Form from '@/components/Form'

	const JOB_TITLES = [
		'Teacher',
		'Coach',
		'Lead Admin',
		'Tech Lead',
		'Site Admin',
		'District Leadership',
		'Parent/Student',
		'Other'
	].map((jobTitle) => ({
		value: jobTitle,
		label: jobTitle
	}))

	export default {
		props: {
			webinar: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				formData: {
					firstName: null,
					lastName: null,
					email: null,
					organization: null,
					jobTitle: null,
					state: null,
					country: 'US'
				}
			}
		},

		computed: {
			schema () {
				return {
					firstName: { required },
					lastName: { required },
					email: { required, email },
					organization: { required },
					jobTitle: { required },
					state: { required },
					country: { required }
				}
			}
		},

		methods: {
			async submitRequest (form) {
				await axios.post(`/api/v1/webinars/${this.webinar.id}/register`, form.formData)
			}
		},

		render () {
			return (
				<Form schema={this.schema} formData={this.formData} onSubmit={this.submitRequest}>
					{({ success }) => (
						success ? (
							<div class="thankyou">
								<h2>Thank you!</h2>
								<p>You will soon receive an email with a link for this webinar.</p>
								<p>If you do not see the email in your inbox, please be sure to check your spam folder or email us at implementation@studysync.com.</p>
							</div>
						) : (
							<Fragment>
								<div class="form__group">
									<Form.Input
										prop="firstName"
										label="First Name"
									/>
									<Form.Input
										prop="lastName"
										label="Last Name"
									/>
								</div>
								<div class="form__group">
									<Form.Input
										type="email"
										prop="email"
										label="Email Address"
										errorMessage={() => `A valid email address is required.`}
									/>
									<Form.Select
										prop="jobTitle"
										label="Job Title"
										options={[
											{ value: '', label: 'Select a job title'},
											...JOB_TITLES
										]}
									/>
								</div>
								<Form.Input
									prop="organization"
									label="School/District"
								/>
								<div class="form__group">
									<Form.Select.Countries
										prop="country"
										label="Country"
									/>
									{this.formData.country === 'US' ? (
										<Form.Select.USStates
											prop="state"
											label="State"
										/>
									) : (
										<Form.Input
											prop="state"
											label="Province"
										/>
									)}
								</div>
							</Fragment>
						)
					)}
				</Form>
			)
		}
	}

</script>



// WEBPACK FOOTER //
// src/components/WebinarForm.vue